import { useIsOnboardingUser } from './useIsOnboardingUser';
import { useAppSelector } from './useAppSelector';
import * as userSlice from '../data/user.slice';

export const useIsOnboardedDriver = (): boolean => {
  const user = useAppSelector(userSlice.selectUserInfo);
  const isOnboarded = !useIsOnboardingUser();
  if (user) {
    const hasDriverRole = user.access?.userRoles?.includes('tp.driver.user');
    return hasDriverRole && isOnboarded;
  }
  return false;
};
